import { render, staticRenderFns } from "./MainAside.vue?vue&type=template&id=2a5a56ed&"
import script from "./MainAside.vue?vue&type=script&lang=js&"
export * from "./MainAside.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports